module.exports = __webpack_public_path__ + "static/img/Q50.c531933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Q50.png
// module id = Slwd
// module chunks = 2